import { defineStore } from 'pinia';

const usePixiStore = defineStore('pixi', {
    state: () => ({
        pixiRedeem: null,
        enableBG: null,
        disableBG: null,
        enableRecursionLogo: null,
        disableRecursionLogo: null
    }),
    getters: {
    },
    actions: {
        setDisableBG(payload) {
            this.disableBG = payload;
        },
        setEnableBG(payload) {
            this.enableBG = payload;
        },
        setPixiRedeem(payload) {
            this.pixiRedeem = payload;
        },
        setDisableRecursionLogo(payload) {
            this.disableRecursionLogo = payload;
        },
        setEnableRecursionLogo(payload) {
            this.enableRecursionLogo = payload;
        }
    }
});

export default usePixiStore;
